import axios from "axios";
import React, { useEffect, useState } from "react";
import { showSuccess, showError } from "component/utils/SweetAlert";

const CategoryForm = ({ mode, categoryData, closeModal, onSuccess }) => {
  const [formData, setFormData] = useState({
    category_id: "",
    name: ""
  });

  useEffect(() => {
    if (mode === "edit" && categoryData) {
      const { name, category_id } = categoryData;
      setFormData({
        category_id: category_id || "",
        name: name || "",
      });
    } else {
      setFormData({
        category_id: "",
        name: "",
      });
    }
  },[mode,categoryData]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const formDataToSend = new FormData();
    Object.keys(formData).forEach((key) => {
      formDataToSend.append(key, formData[key]);
    });

    try {
      const response = await axios({
        method: mode === "add" ? "POST" : "PUT",
        url:
          mode === "add"
            ? `${process.env.REACT_APP_API}/category`
            : `${process.env.REACT_APP_API}/category/${categoryData.category_id}`,
        data: formDataToSend,
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      if (response.status === 200 || response.status === 201) {
        showSuccess(mode === "add" ? "category berhasil ditambahkan" : "category berhasil diperbarui");
        closeModal();
        if (onSuccess) onSuccess();
      } else {
        showError(mode === "add" ? "Gagal menambahkan category" : "Gagal memperbarui category");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (        
    <div className="modal-dialog">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{mode === "add" ? "Tambah Category" : "Edit Category"}</h5>
          <button type="button" className="btn-close" onClick={closeModal}></button>
        </div>
        <div className="modal-body">
          
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div class="form-group mb-4">
            <label for="name" class="form-label">Nama Category</label>
            <input 
              class="form-control"
              type="text" 
              name="name"
              placeholder="Isi Nama Category"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <button type="submit" class="btn btn-primary">
            {mode === "add" ? "Save" : "Update"}
          </button>
        </form>
          
        </div>
      </div>
    </div>
  );
};

export default CategoryForm;
